import { render, staticRenderFns } from "./MealsTypeForm.vue?vue&type=template&id=ed2e135a&scoped=true&"
import script from "./MealsTypeForm.vue?vue&type=script&lang=js&"
export * from "./MealsTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2e135a",
  null
  
)

export default component.exports